import {BackendError, NotificationMessageVars, NotificationVariant} from "./types";
import {MessageDescriptor} from "react-intl";

export enum Action {
    SHOW_NOTIFICATION = "SHOW_NOTIFICATION",
    HIDE_NOTIFICATION = "HIDE_NOTIFICATION",
    SET_BACKEND_ERROR = "SET_BACKEND_ERROR",
    GQL_QUERY_REQUEST = "GQL_QUERY_REQUEST",
    GQL_QUERY_RESPONSE = "GQL_QUERY_RESPONSE",
}

export const showNotification = (
    message: MessageDescriptor,
    variant: NotificationVariant = "success",
    vars: NotificationMessageVars = {},
    autoHideDuration = 5000,
) => ({
    type: Action.SHOW_NOTIFICATION,
    message,
    variant,
    vars,
    autoHideDuration,
});

export const hideNotification = () => ({
    type: Action.HIDE_NOTIFICATION,
});

export const setBackendError = (error: BackendError) => ({
    type: Action.SET_BACKEND_ERROR,
    error,
});

export const clearBackendError = () => ({
    type: Action.SET_BACKEND_ERROR,
    error: null as BackendError | null,
});

export type GraphqlQueryAction = {id: string; type: Action};

export const startGraphqlQuery = (id: string) =>
    ({
        type: Action.GQL_QUERY_REQUEST,
        id,
    }) as GraphqlQueryAction;

export const stopGraphqlQuery = (id: string) =>
    ({
        type: Action.GQL_QUERY_RESPONSE,
        id,
    }) as GraphqlQueryAction;
